/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentSpecs = require('../libs/ComponentSpecs');
var React = require('react');
var ReactI13n = require('../libs/ReactI13n');
var augmentComponent = require('./augmentComponent');
var hoistNonReactStatics = require('hoist-non-react-statics');
var IS_CLIENT = typeof window !== 'undefined';
var debugLib = require('debug');
var debug = debugLib('ReactI13n');

/**
 * Create an app level component with i13n setup
 * @param {Object} Component the top level component
 * @param {Object} options passed into ReactI13n
 * @param {Boolean} options.isViewportEnabled if enable viewport checking
 * @param {Object} options.rootModelData model data of root i13n node
 * @param {Object} options.i13nNodeClass the i13nNode class, you can inherit it with your own functionalities
 * @param {Object} options.displayName display name of the wrapper component
 * @param {Boolean} options.skipUtilFunctionsByProps true to prevent i13n util function to be passed via props.i13n
 * @param {Array} plugins plugins
 * @method setupI13n
 */
module.exports = function setupI13n(Component, options, plugins) {
    options = options || {};
    plugins = plugins || [];

    if (!plugins.length) {
        debug('no plugins provided');
    }

    var RootI13nComponent = function (_React$Component) {
        _inherits(RootI13nComponent, _React$Component);

        function RootI13nComponent(props) {
            _classCallCheck(this, RootI13nComponent);

            return _possibleConstructorReturn(this, (RootI13nComponent.__proto__ || Object.getPrototypeOf(RootI13nComponent)).call(this, props));
        }

        _createClass(RootI13nComponent, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var reactI13n = new ReactI13n(options);
                this._reactI13nInstance = reactI13n;
                // we might have case to access reactI13n instance to execute event outside react components
                // assign reactI13n to window
                if (IS_CLIENT) {
                    window._reactI13nInstance = reactI13n;
                }
                plugins.forEach(function setPlugin(plugin) {
                    reactI13n.plug(plugin);
                });
                reactI13n.createRootI13nNode();
            }
        }, {
            key: 'render',
            value: function render() {
                var props = Object.assign({}, this.props);
                if (!options.skipUtilFunctionsByProps) {
                    props.i13n = {
                        executeEvent: this.executeI13nEvent.bind(this),
                        getI13nNode: this.getI13nNode.bind(this),
                        reactI13nInstance: this._reactI13nInstance
                    };
                }
                return React.createElement(Component, props, props.children);
            }
        }]);

        return RootI13nComponent;
    }(React.Component);

    var specs = ComponentSpecs.pickSpecs({
        prototype: ['getChildContext', 'executeI13nEvent', 'getI13nNode', '_getReactI13n', '_getParentI13nNode'],
        static: ['contextTypes', 'childContextTypes']
    });

    var componentName = Component.displayName || Component.name;
    augmentComponent(RootI13nComponent, specs.prototype, Object.assign({}, specs.static, {
        displayName: options.displayName || 'RootI13n' + componentName
    }));

    hoistNonReactStatics(RootI13nComponent, Component);

    return RootI13nComponent;
};
